import { Column } from 'ui/indexPages/tables/header/constants';

import { SnippetFields, SnippetFieldsInputIds, fieldMapType } from './types';

export const SNIPPET_TABLE_COLUMNS: Column[] = [
  { id: 'Name', label: 'Name', isSortable: true },
  { id: 'Snippet', label: 'Snippet', isSortable: false },
  { id: 'UpdatedAt', label: 'Last modified', isSortable: true },
];

export const USAGE_TABLE_COLUMNS: Column[] = [
  { id: 'name', label: 'Name', isSortable: true },
  { id: 'messageMedium', label: 'Medium', isSortable: true },
  { id: 'resultType', label: 'Type', isSortable: true },
  { id: 'campaignState', label: 'Status', isSortable: true },
  { id: 'updatedAt', label: 'Last Modified', isSortable: true },
];

export const defaultSortField = SNIPPET_TABLE_COLUMNS[2].id;

export enum QUERY_PARAMS {
  SORT_DIRECTION = 'sortDirection',
  SORT_BY = 'sortBy',
  SEARCH = 'search',
  PAGE = 'page',
  PAGE_SIZE = 'pageSize',
}

export const SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS = 500;

export const snippetUrlList = `/templates/snippets`;
export const snippetUrlNew = `/templates/snippet/create`;
export const snippetSupportUrl = `https://support.iterable.com/hc/en-us/articles/5321528624020`;

// map the BE field to the FE fieldId to provide field-specific error messaging
export const fieldMap: fieldMapType = {
  [SnippetFields.content]: {
    fieldId: SnippetFieldsInputIds.content,
    name: 'Snippet content',
  },
  [SnippetFields.description]: {
    fieldId: SnippetFieldsInputIds.description,
    name: 'Snippet description',
  },
  [SnippetFields.name]: {
    fieldId: SnippetFieldsInputIds.name,
    maxLength: 100,
    name: 'Snippet name',
  },
  [SnippetFields.positionalParameters]: {
    fieldId: SnippetFieldsInputIds.positionalParameters,
    maxLength: 100,
    name: 'Variable names',
  },
  default: {
    fieldId: '',
    name: 'Form field',
  },
};

export enum ModalIntent {
  edit = 'edit',
  list = 'list',
}
